<template>
  <div class="chat-view">
    <div id="snackbar">{{snackbar.text}}</div>
    <modal class="lot-modal-info" :show.sync="showModal" body-classes="p-0" modal-classes="modal-dialog-centered">
      <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-4 py-lg-5" class="border-0">
        <div class="row">
          <div class="col-12">

            <div class="container h-100" style="text-align: left !important;">
              <div class="row px-3">
                <h3 class="pt-2 mb-0" style="color:black; font-size: 1.35rem !important;"><b>Datos del lote</b></h3>
              </div>
              <hr class="mt-1 mb-2">
              <div class="row px-3">
                <h4 class="pt-2 mb-0" style="color:black; font-size: 1.25rem !important;"><b>Lote de {{ lot.area }}ha</b></h4>
              </div>
              <div class="row px-3">
                <p class="mb-0">En {{ lot.nearestCity }}</p>
              </div>
              <div class="row mt-3">
                <div class="col text-left">
                  <h4 class="mb-0" style="color:black; font-size: 1.25rem !important;"><b>Servicios</b></h4>
                  <ul class="pl-2 pt-0" style="max-height: 130px; overflow-y: auto;">
                    <li v-for="(service, index) in lot.services" :key="index" style="list-style-type: none">
                      ✓ {{ service.description }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row px-3" style="flex-direction: column;">
                <h4 class="mb-0" style="color:black; font-size: 1.25rem !important;"><b>Descripción</b></h4>
                <p class="mb-0 text-left pl-2">{{ lot.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </card>
    </modal>
    <div v-if="loading" class="loader" style="margin: auto;"/>
    <div v-if="chatStatus === 'loaded'" style="flex-grow: 1; display: flex; flex-direction: column;">
      <div class="lot-info-container" @click="onInfoClick">
        <img class="lot-img" alt="Imagen del lote" :src="lot.satelliteImages !== '' ? lot.satelliteImages : require('../assets/images/default-satellite-image.webp')">
        <div class="lot-info">
          <h3 class="lot-title">Lote de {{ lot.area }} ha en {{ lot.nearestCity }}</h3>
          <p v-if="solicitantsNames.length > 0" class="lot-subtitle">Solicitantes: {{ solicitantsNames.join(', ') }}</p>
        </div>
      </div>
      <div class="countdown">
        Tiempo restante de conversación: <b>{{ timeUntilExpire }}</b>
      </div>
      <div class="chat-container">
        <minnit-chat class="chat" :data-chatname="`https://organizations.minnit.chat/626119570806091/${this.chatId}?embedmobile&bright&language=es&ssotoken='${this.token}'`" data-style="width:100%;flex-grow:1"></minnit-chat>
      </div>
    </div>
    <div v-if="chatStatus === 'not_found'" class="not-found-container">
      <icon name="fa fa-exclamation-circle" size="xxl"/>
      <p class="not-found-text">
        El chat no existe
      </p>
    </div>
  </div>
</template>
<script>
import Modal from '../components/Modal'

export default {
  components: {
    Modal
  },
  data() {
    return {
      showModal: false,
      chatId: this.$route.query.id,
      contactId: this.$route.query.recordid,
      snackbar: {
        text: '',
        color: ''
      },
      loading: true,
      chatStatus: 'loading',
      token: '',
      lot: {},
      solicitantsNames: [],
      expirationDate: '',
    }
  },
  async mounted() {
    await this.getChatInfo()
  },
  methods: {
    async getChatInfo () {
      try {
        const headers = new Headers()
        headers.append("Content-Type", "application/json")
        var requestOptions = {
          method: 'POST',
          headers,
          body: JSON.stringify({
            chatId: this.chatId,
            contactId: this.contactId
          })
        }

        const response = await fetch(`${process.env.VUE_APP_API_URL}/chat/createToken`, requestOptions)

        if (!response.ok) throw new Error()

        const { token, lot, solicitantsNames, expirationDate, status } = await response.json()

        if (status && status !== 200) {
          this.chatStatus = 'not_found'
        } else {
          this.token = token
          this.lot = lot
          this.solicitantsNames = solicitantsNames
          this.expirationDate = new Date(expirationDate)
          this.chatStatus = 'loaded'
        }
      } catch (e) {
        console.log('Error:', e)
        this.snackbar.text = 'Error obteniendo los datos del chat. Por favor, recargue la página'
        this.snackbar.color = 'error'
        this.showSnackbar()
      } finally {
        this.loading = false
      }
    },
    onInfoClick () {
      this.showModal = true
    },
    showSnackbar () {
      let x = document.getElementById("snackbar")
      x.className = `${this.snackbar.color} show`
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000)
    }
  },
  computed: {
    timeUntilExpire () {
      const now = new Date()
      const diff = this.expirationDate - now

      if (diff <= 0) {
        return '0m'
      }

      const minutes = Math.floor(diff / (1000 * 60)) % 60;
      const hours = Math.floor(diff / (1000 * 60 * 60)) % 24;
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));

      // Format the output
      if (days > 0) {
        return `${days}d ${hours}h`;
      } else if (hours > 0) {
        return `${hours}h ${minutes}m`;
      } else {
        return `${minutes}m`;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.chat-view {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  position: relative;
}
.chat-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.chat {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.lot-info-container {
  z-index: 1;
  display: flex;
  background-color: #F5F5F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
.lot-img {
  height: 4rem;
}
.lot-info {
  flex-grow: 1;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.lot-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}
.lot-subtitle {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 400;
}
.countdown {
  position: absolute;
  top: 5rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.25rem 1rem;
  background-color: #FFEA9B;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5);
}

.not-found-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.not-found-text {
  font-size: 2rem;
}
</style>